import React from 'react';
import {useModelFormEngine} from "../common/hooks/useModelFormEngine";
import {ApiUtility} from "../common/ApiUtility";
import {EmailUtility} from "../common/EmailUtility";
import {CommonCustomerForm} from "./CommonCustomerForm";
import _ from "lodash";

export let QboCustomerForm = function (props) {
    let customer = _.clone(props.customer) || {};
    let showingProposedValues = props.isNew && (customer.name || customer.email)

    const initialModelState = {
        name: customer.name || '',
        email: customer.email || ''
    };

    const formEngine = useModelFormEngine(initialModelState, {}, null, validateForm, null, props.save);

    function validateForm(handleValidationResult) {
        return new Promise(function (resolve, reject) {
            let validationErrors = [];
            let invalidFields = [];

            Promise.resolve({})
                .then(function () {
                    if (!EmailUtility.isValid(formEngine.renderableData.email)) {
                        validationErrors.push('Please enter a valid email address.');
                        invalidFields.push('email');
                        return Promise.resolve({})
                    } else {
                        return ApiUtility.getIsQboCustomerEmailAvailable(formEngine.renderableData.email)
                            .then(function (availabilityData) {
                                if (!availabilityData.isEmailAvailable) {
                                    validationErrors.push(`Another QBO customer is already using that email. Please enter a different email.`);
                                    invalidFields.push('email');
                                }

                                return Promise.resolve({})
                            })
                            .catch(function (error) {
                                console.log("Error validating form: ", error);
                                reject("An error occurred while validating the form.")
                            })
                    }
                })
                .then(function () {
                    if (!formEngine.renderableData.name) {
                        validationErrors.push('Please enter a name.');
                        invalidFields.push('name');
                        return Promise.resolve({})
                    } else {
                        return ApiUtility.getIsQboCustomerNameAvailable(formEngine.renderableData.name)
                            .then(function (availabilityData) {
                                if (!availabilityData.isNameAvailable) {
                                    validationErrors.push(`Another QBO customer is already using that name. Please enter a different name.`);
                                    invalidFields.push('name');
                                }

                                return Promise.resolve({})
                            })
                            .catch(function (error) {
                                console.log("Error validating form: ", error);
                                reject("An error occurred while validating the form.")
                            })
                    }
                })
                .then(function () {
                    return handleValidationResult(validationErrors, invalidFields, resolve);
                });
        });
    }

    return (
        <CommonCustomerForm
            headerText={props.headerText}
            cancel={props.cancel}
            showingProposedValues={showingProposedValues}
            formEngine={formEngine}
        />
    );
};
